import dayjs from 'dayjs';

export interface Time {
  // milliseconds since 1970.01.01.
  milliseconds: number;
}

export function defaultTime(): Time {
  return {
    milliseconds: 0
  };
}

export function timeToString(time: Time): string {

  const format = 'YYYY-MM-DDTHH:mm:ss.00Z';
  const formatted = dayjs(time.milliseconds).format(format);
  return formatted;
}

export function parseTime(value: string): Time | false {

  const parsed = dayjs(value);
  const milliseconds = parsed.valueOf();
  if (isNaN(milliseconds)) {
    return false;
  }
  return { milliseconds };
}
